import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Sidebar interaction is tracked',
  name: 'sidebar_interaction',
  params: [
    {
      description: 'The type of sidebar interaction',
      name: 'type',
      required: true,
      type: 'enum',
      values: [
        'board',
        'library',
        'search',
        'saved_searches',
        'people',
        'recently_added',
        'recently_deleted',
        'skills',
        'automations',
        'my_uploads',
        'my_favorites',
        'recently_modified',
        'unused_items',
        'untagged_items',
        'share_links',
        'canvases',
        'creative_performance',
        'context_sources',
        'settings',
      ],
    },
    {
      description: 'The action performed on the sidebar item',
      name: 'action',
      required: true,
      type: 'enum',
      values: ['expand', 'collapse', 'create_board', 'open_sub_menu', 'link_click', 'link_click_and_expand'],
    },
  ],
};

export default META;
